import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import i18n from "../i18n";

const t = (key) => i18n.global.t(key);

const Alert = {
  showError(message, callback = null) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: t("common.alert.error.title"),
        html: message,
        icon: "error",
        confirmButtonText: t("common.alert.buttons.ok"),
      })
        .then((value) => resolve(value))
        .catch((error) => reject(error));
    });
  },
  showInfo(message) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: t("common.alert.info.title"),
        html: message,
        icon: "info",
        confirmButtonText: t("common.alert.buttons.ok"),
      })
        .then((value) => resolve(value))
        .catch((error) => reject(error));
    });
  },
  showSuccess(message) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: t("common.alert.success.title"),
        html: message,
        icon: "success",
        confirmButtonText: t("common.alert.buttons.ok"),
      })
        .then((value) => resolve(value))
        .catch((reason) => reject(reason));
    });
  },
  showWarning(message) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: t("common.alert.warning.title"),
        html: message,
        icon: "warning",
        confirmButtonText: t("common.alert.buttons.ok"),
      })
        .then((value) => resolve(value))
        .catch((error) => reject(error));
    });
  },
  showPrompt(message, buttons = null) {
    if (!buttons) {
      buttons = {
        confirmText: t("common.alert.buttons.yes"),
        cancelText: t("common.alert.buttons.no"),
      };
    }
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: t("common.alert.note.title"),
        html: message,
        icon: "warning",
        showCancelButton: true,
        focusCancel: true,
        cancelButtonColor: "#d33",
        confirmButtonText: buttons.confirmText,
        cancelButtonText: buttons.cancelText,
      })
        .then((value) => resolve(value))
        .catch((reason) => reject(reason));
    });
  },
  showInput(message) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: t("common.alert.note.title"),
        html: message,
        icon: "warning",
        showCancelButton: true,
        focusConfirm: false,
        input: "text",
        confirmButtonText: t("common.alert.buttons.ok"),
        cancelButtonColor: "#d33",
        cancelButtonText: t("common.alert.buttons.cancel"),
      })
        .then((value) => {
          resolve(value);
        })
        .catch((reason) => {
          reject(reason);
        });
    });
  },
};

export default Alert;
